import React, { useState } from "react";
import { useDateFilter } from "./_40b_date_filter_context.js";
import "./styles.css";
import TopHeader from "./nav_top.js";
import LargestOpenPosChart from "./_13_current_week_largest_open_pos_chart.js";
//import DailyLogMain from "./_7_daily_log_main.js";
import ProfitChart from "./_5_profit_chart.js";
import DetailsPage from "./_pg_details.js";


import { useTagFilter } from "./TagFilterContext.js";
import LargestOpenPosTable from "./_13_current_week_largest_open_pos_table.js";

const MODULE_NAME = "Home MN";

function GradientSeparator() {
    // Check if module_name is in URL - if so, don't show gradient
    const hasModuleName = React.useMemo(() => {
        if (typeof window === 'undefined') return false;
        const params = new URLSearchParams(window.location.search);
        return !!params.get('module_name');
    }, []);

    // Return null if module_name is present
    if (hasModuleName) return null;

    return (
        <div
            style={{
                height: 8,
                width: "100%",
                background: "linear-gradient(90deg, #0a2342 0%, #CCC 100%)",
                margin: "24px 0"
            }}
        />
    );
}

// Inner component that uses the context
function TodayMainPageContent({ refreshKey, screen, setScreen }) {
    const { navigationDate } = useDateFilter();
    const { globalTagFilter } = useTagFilter();

    let effectiveDate = navigationDate;
    if (!effectiveDate) {
        effectiveDate = sessionStorage.getItem("latest_date");
    }
    if (!effectiveDate) {
        effectiveDate = null;
    }

    const storedId = sessionStorage.getItem("user_id");
    const userId = storedId && !isNaN(Number(storedId)) ? Number(storedId) : 1;

    const [activeDate, setActiveDate] = useState(null);
    const [notesCollapsed, setNotesCollapsed] = useState(true);

    // Check if module_name is in URL - if so, don't show navigation
    const hasModuleName = React.useMemo(() => {
        if (typeof window === 'undefined') return false;
        const params = new URLSearchParams(window.location.search);
        return !!params.get('module_name');
    }, []);

    function handleNavigate(targetScreen, date) {
        console.log("Navigating to:", targetScreen, "with date:", date);
        if (targetScreen === "pg_details") {
            sessionStorage.setItem("navigationDate", date);
        }
        if (typeof setScreen === "function") {
            setScreen(targetScreen);
        } else {
            console.warn("setScreen is not a function");
        }
        setActiveDate(date);
    }

    return (
        <div className="main-dash-container" style={{ maxWidth: 3000, margin: "0 auto", padding: "0 0 0 0" }} data-analytics={MODULE_NAME}>
            {!hasModuleName && <TopHeader userId={userId} activeDate={effectiveDate} screen={screen} setScreen={setScreen} refreshKey={refreshKey} />}
            <GradientSeparator />



            {screen === "pg_details" ? (
                <DetailsPage
                    date={null}
                    refreshKey={refreshKey}
                    screen={screen}
                    setScreen={setScreen}
                />
            ) : (
                <>
                    <LargestOpenPosChart
                        onNavigate={handleNavigate}
                        screen={screen}
                        activeDate={effectiveDate}
                        userId={userId}
                        tagFilter={globalTagFilter}
                        refreshKey={refreshKey}
                    />
                    <LargestOpenPosTable
                        onNavigate={handleNavigate}
                        screen={screen}
                        activeDate={effectiveDate}
                        userId={userId}
                        tagFilter={globalTagFilter}
                        refreshKey={refreshKey}
                        />

                    
                       
                </>
            )}

            <ProfitChart 
                userId={userId} 
                activeDate={effectiveDate} 
                screen={screen} 
                tagFilter={globalTagFilter}
                refreshKey={refreshKey} 
            />

            <GradientSeparator />
        </div>
    );
}

// ✅ Export WITHOUT wrapping in DateFilterProvider (it's already provided by App.js)
export default function TodayMainPage({ refreshKey, setRefreshKey, screen, setScreen }) {
    return <TodayMainPageContent refreshKey={refreshKey} screen={screen} setScreen={setScreen} />;
}